import React from 'react';
type Brand = {
  name: string;
  src?: string;
  wordmark?: 'aspen' | 'multi-radiance' | 'lumanova' | 'brand';
};
const BRANDS: Brand[] = [{
  name: 'Aspen Laser',
  wordmark: 'aspen'
}, {
  name: 'Multi Radiance Medical',
  wordmark: 'multi-radiance'
}, {
  name: 'LumaNova',
  wordmark: 'lumanova'
}, {
  name: 'TheraLight',
  src: 'https://cdn.magicpatterns.com/uploads/vttP1Sb7gikoGaFWY35ZNt/theralight-logo-tight.png'
}, {
  name: 'ThermoVision',
  wordmark: 'brand'
}, {
  name: 'WellVu',
  src: 'https://cdn.magicpatterns.com/uploads/qMimGwm5vM6HRxKcW7oosi/wellvu-logo.png'
}, {
  name: 'RegenOMedix',
  wordmark: 'brand'
}, {
  name: 'Pain-Wave',
  wordmark: 'brand'
}, {
  name: 'CTN-USA',
  wordmark: 'brand'
}, {
  name: 'Invisared',
  wordmark: 'brand'
}, {
  name: 'Hydrowave',
  wordmark: 'brand'
}, {
  name: 'Visnova',
  wordmark: 'brand'
}, {
  name: 'Summus',
  wordmark: 'brand'
}, {
  name: 'Neuroreformer',
  wordmark: 'brand'
}, {
  name: 'Team Medical Group',
  wordmark: 'brand'
}];
function BrandMark({
  brand
}: {
  brand: Brand;
}) {
  if (brand.src) {
    return <img src={brand.src} alt={`${brand.name} logo`} className="manufacturer-strip__logo block h-7 w-full max-w-[104px] object-contain" data-id="element-423" data-mp="2j856jmshsn6e" />;
  }
  switch (brand.wordmark) {
    case 'aspen':
      return <span className="flex w-full max-w-full flex-col items-center justify-center px-2 text-center leading-none" data-id="element-424" data-mp="2t7e1oiz3g7uc">
          <span className="text-[14px] font-extrabold tracking-[0.02em] text-teal" data-id="element-425" data-mp="2y5fisycylx36">ASPEN</span>
          <span className="mt-1 text-[10px] font-semibold tracking-[0.08em] text-navy/75" data-id="element-426" data-mp="325g7rcxopqoh">LASER</span>
        </span>;
    case 'multi-radiance':
      return <span className="flex items-center gap-1.5 whitespace-nowrap text-navy" data-id="element-427" data-mp="3bw122o6bs91l">
          <span className="flex h-4 w-4 items-center justify-center rounded-full border border-teal/60" data-id="element-428" data-mp="3gwp382o9q69j">
            <span className="h-1.5 w-1.5 rounded-full bg-teal" data-id="element-429" data-mp="3lugucuh39oco" />
          </span>
          <span className="flex flex-col leading-none" data-id="element-430" data-mp="2w6ux5esiiydg">
            <span className="text-[12px] font-bold tracking-[-0.04em]" data-id="element-431" data-mp="2w7e4k1kje4d8">Multi Radiance</span>
            <span className="mt-0.5 text-[7px] font-semibold uppercase tracking-[0.14em] text-teal" data-id="element-432" data-mp="2r9kzjbuyzgej">
              Medical
            </span>
          </span>
        </span>;
    case 'lumanova':
      return <span className="flex items-center gap-1.5 whitespace-nowrap text-navy" data-id="element-433" data-mp="3144jglklutx2">
          <span className="h-3 w-3 rounded-full border-[3px] border-teal" data-id="element-434" data-mp="3ew16wcbbwfn4" />
          <span className="text-[17px] font-bold tracking-[-0.05em]" data-id="element-435" data-mp="39xhkkastp1u8">LumaNova</span>
        </span>;
    case 'brand':
      return <span className="max-w-full px-1 text-center text-[12px] font-bold leading-tight tracking-[-0.02em] text-navy sm:text-[13px]" data-id="element-436" data-mp="3otpg279olpot">
          {brand.name}
        </span>;
    default:
      return null;
  }
}
export function ManufacturerStrip() {
  return <section className="manufacturer-strip w-full max-w-full overflow-x-hidden border-y border-slate-200 bg-slate-50/90" data-id="element-437" data-mp="1pjpmlh27mofv">
      <div className="manufacturer-strip__inner mx-auto w-full max-w-7xl box-border overflow-x-hidden px-5 py-7 sm:px-8" data-id="element-438" data-mp="515b3u876f5b">
        <p className="manufacturer-strip__heading mx-auto max-w-full whitespace-normal break-words px-2 text-center text-[11px] font-semibold uppercase leading-snug tracking-[0.16em] text-charcoal/55" data-id="element-439" data-mp="a1jcitfamqud">
          <span className="manufacturer-strip__heading-mobile" data-id="element-440" data-mp="7kdi3ainn6n">Our Partners</span>
          <span className="manufacturer-strip__heading-desktop" data-id="element-441" data-mp="3ihmjsy2hudi6">Our Partners</span>
        </p>
        <ul className="manufacturer-strip__chips mx-auto mt-4 grid w-full max-w-[300px] grid-cols-1 gap-2.5 sm:max-w-7xl sm:grid-cols-3 md:grid-cols-5 lg:grid-cols-9 lg:gap-2" aria-label="Trusted modality brands" data-id="element-442" data-mp="3mig9nwzhy2dp">
          {BRANDS.map(brand => <li key={brand.name} className={`flex h-14 min-w-0 w-full items-center justify-center rounded-xl border border-slate-200 bg-white px-3 shadow-[0_3px_10px_-7px_rgba(26,27,75,0.34)] ${brand.wordmark === 'aspen' ? 'overflow-visible' : 'overflow-hidden'}`} data-id="element-443" data-mp="16ragdj9h5qcu">
              <BrandMark brand={brand} data-id="element-444" data-mp="32tna9ijffyty" />
            </li>)}
        </ul>
      </div>
    </section>;
}